import React, { useEffect, useRef } from "react";
import styles from "./MyOrders.module.css";
import { useState } from "react";

import { Button } from "primereact/button";
import {  useNavigate } from "react-router-dom";
import { getTokenInfo } from "../../../utils/Guard";
import { useDispatch, useSelector } from "react-redux";
import {
  GetUserById,
  GetOrdersByUserId
} from "../../../store/auth-store/auth-actions";
import ABADatatable from "../../../components/abaDataTable/ABADatatable";
import { TabPanel, TabView } from "primereact/tabview";
import { Tag } from "primereact/tag";
import { DownloadQuote } from "../../../store/orden-store/orden-actions";
import Loading from "../../../components/loading/Loading";
import { Dialog } from "primereact/dialog";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";

let courses = {};

const MyOrders = () => {
  const userInfo = getTokenInfo();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const notification = useSelector((state) => state.ui.notification);
  const user = useSelector((state) => state.auth.auth);
  const userOrders = useSelector((state) => state.orden.orden);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [courseNotAvailableModal, setCourseNotAvailableModal] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const stepperRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);


  useEffect(() => {
    if (notification !== null && notification !== undefined && notification.message !== null && notification.message !== undefined && (notification.message === "Curso no encontrado." || notification.message === "No se encontro la orden.")) {
      window.location.href = "/courses/none";
    }
  }, [notification]);

    useEffect(() => {
      if (
        userInfo === undefined ||
        userInfo === null ||
        userInfo.UserId === undefined ||
        userInfo.UserId === null ||
        userInfo.UserId === ""
      ) {
        window.location.href = "/";
      }
    }, [userInfo]);

  const ordersHeaderTemplate = (data) => {
    return (
      <div className={styles.header}>
        <h1
          style={{
            color: activeIndex === 0 ? "#1f3564" : "gray",
            opacity: activeIndex === 0 ? "1" : "0.5",
          }}
          onClick={() => setActiveIndex(0)}
        >
          Mis órdenes
        </h1>
      </div>
    );
  };
  const quotesHeaderTemplate = (data) => {
    return (
      <div className={styles.header}>
        <h1
          style={{
            color: activeIndex === 1 ? "#1f3564" : "gray",
            opacity: activeIndex === 1 ? "1" : "0.5",
          }}
          onClick={() => setActiveIndex(1)}
        >
          Mis cotizaciones
        </h1>
      </div>
    );
  };

  useEffect(() => {
    if (
      (userInfo !== undefined &&
        userInfo !== null &&
        userInfo.UserId !== undefined &&
        userInfo.UserId !== null &&
        user.name === "") ||
      user.length === 0
    ) {
      dispatch(GetUserById(userInfo.UserId, userInfo.Email, null));
    }
  }, []);

  useEffect(() => {
    if (
      (userInfo !== undefined &&
        userInfo !== null &&
        userInfo.UserId !== undefined &&
        userInfo.UserId !== null &&
        user.name === "") ||
      user.length === 0
    ) {
      setIsLoading(true);
      dispatch(GetOrdersByUserId(userInfo.UserId, userInfo.Email, null, true));
    }
  }, []);

  useEffect(() => {
    if (notification !== null && notification !== undefined && notification.status !== undefined && notification.status == "success") {
      setTimeout(function () {
        setIsLoading(false);
      }, 2500);
    }
  }, [notification]);

  const viewDetailHandlder = (val) => {

    dispatch(DownloadQuote(userInfo.id, val.id, userInfo.Email));
  };
  const payHandlder = (val) => {
    navigate(`/payQuote/${val.id}/${val.courseId}`);
  };




  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonBuy = !rowData.course.isBought && (
      <Button
        label="Pagar"
        icon="pi pi-shopping-cart"
        className="p-button-rounded p-button-text buy-button"
        style={{ color: "#FFB321", fontWeight: "bold" }}
        onClick={() => {
          const today = new Date();

          const splitEndDate= rowData.course.endDate.split("-");
          const splitStartDate= rowData.course.startDate.split("-");

          const newEndDate = new Date(rowData.course.endDate);
          const newStartDate = new Date(rowData.course.startDate);

          setSelectedRow(rowData);
  
          rowData.course.currentEnrollment >= rowData.course.maxEnrollment || newEndDate < today ? setCourseNotAvailableModal(true) :
            today >= newStartDate ? setShowDisclaimer(true) :
              payHandlder(rowData);
        }}
      />
    );
    const buttonQuote = !rowData.course.isBought && (
      <Button
        label="Descargar"
        icon="pi pi-download"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHandlder(rowData);
        }}
      />
    );
    if (rowData.ordenStatusId === 9) {
      buttons.push(buttonBuy);
    }
    if (rowData.ordenStatusId === 9) {
      buttons.push(buttonQuote);
    }
    return buttons;
  };
  actions.push(buttons);

  const columns = [
    {
      field: "id",
      header: "Id de la orden",
      filterMatchMode: "contains",
    },
    {
      field: "course.topic",
      header: "Curso",
      body: (rowData) => {
        return (

          <span onClick={() => window.location.href = `/courseinfo/${rowData.course.id}`} className={styles.orderCourse}>{rowData.course.topic}</span>

        );
      },
    },
    {
      // field: "status.description",
      header: "Status",
      filterMatchMode: "contains",
      body: (rowData) => {
        return (

          <Tag style={{ background: rowData.status.color }}>
            <div className="flex align-items-center gap-2">
              {/* <img alt="Country" src="/images/flag/flag_placeholder.png" className="flag flag-it" style={{ width: '18px' }}/> */}
              <span className="text-base">{rowData.status.description}</span>
            </div>
          </Tag>
        );
      },
    },
    {
      field: "creationDate",
      header: "Fecha",
      filterMatchMode: "contains",
      body: (rowData) => {
        return (
          <div>
            <span>{rowData.creationDate.split("T")[0]}</span>
          </div>
        );
      },
    },
  ];
  
  if (isLoading) {
    return <Loading />;
  }

  return (
    <div>
      <>
        {userInfo !== null && userInfo.UserId !== undefined && !isLoading && (
          <div className={styles.orders}>
            <TabView
              style={{ borderWidth: "0px 0px 0px 0px" }}
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel
                header="Mis órdenes"
                headerTemplate={ordersHeaderTemplate}
                headerClassName="flex align-items-center"
              >
                <ABADatatable
                  width="20%"
                  values={(userOrders !== null && userOrders !== undefined && userOrders.length > 0) ? userOrders.filter(
                    (order) => order.ordenStatusId !== 9 && order.courseId > 0
                  ) : []}
                  rows={5}
                  // rowsPerPageOptions={[5, 10, 20]}
                  Columns={columns}
                  actions={actions}
                  alwaysShowPaginator={false}
                  dontshowMenu
                  createButton={
                    {
                      // label: "Crear Cargo",
                      // onClick: createHandlder,
                      // permission: "charge.create",
                    }
                  }
                  backButton={
                    {
                      // label: "Regresar",
                      // onClick: backHanlder,
                      // permission: "goBack",
                    }
                  }
                />
              </TabPanel>
              <TabPanel
                header="Mis cotizaciones"
                headerTemplate={quotesHeaderTemplate}
                headerClassName="flex align-items-center"
              >
                <ABADatatable
                  width="20%"
                  values={(userOrders !== null && userOrders !== undefined && userOrders.length > 0) ? userOrders.filter(
                    (order) => order.ordenStatusId === 9 && order.courseId > 0
                  ) : []}
                  rows={5}
                  // rowsPerPageOptions={[5, 10, 20]}
                  Columns={columns}
                  actions={actions}
                  alwaysShowPaginator={false}
                  dontshowMenu
                  createButton={
                    {
                      // label: "Crear Cargo",
                      // onClick: createHandlder,
                      // permission: "charge.create",
                    }
                  }
                  backButton={
                    {
                      // label: "Regresar",
                      // onClick: backHanlder,
                      // permission: "goBack",
                    }
                  }
                />
              </TabPanel>
            </TabView>
          </div>
        )}
      </>
      <Dialog
        modal={true}
        closable={true}
        visible={courseNotAvailableModal}
        onHide={() => setCourseNotAvailableModal(false)}
        header="Alerta"
      >
        <div>
          <h1 className="text-xl p-4">
            Este curso no está disponible actualmente
          </h1>
        </div>
      </Dialog>
      <Dialog
        modal={true}
        closable={true}
        visible={showDisclaimer}
        onHide={() => setShowDisclaimer(false)}
      >
        <div>
          <Stepper ref={stepperRef}>
            <StepperPanel header="Lista de espera">
              <h1 className="text-xl">
                Este curso ya comenzó, ¿Estás seguro que quieres continuar?
              </h1>
              <div className="flex align-items-center justify-content-center gap-3">
                <Button
                  label="Sí"
                  onClick={() => {
                    payHandlder(selectedRow)
                  }}
                  className={styles.buttonYes}
                />
                <Button
                  label="No"
                  onClick={() => setShowDisclaimer(false)}
                  className={styles.buttonNo}
                />
              </div>
            </StepperPanel>
          </Stepper>
        </div>
      </Dialog>

    </div>
  );
};

export default MyOrders;
